"use client";


import { useRouter, useParams } from "next/navigation";

import type { Workspace } from "~/workspaces/state/workspace";
import { useGetWorkspaces } from "~/workspaces/queries/get-workspaces-query";
import type { ParamsOf } from ".next/types/routes";

function useWorkspace() {
  const router = useRouter();
  const params = useParams<ParamsOf<"/[workspace]">>();
  const workspaceSlug = params.workspace;

  const { data: workspace } = useGetWorkspaces((workspaces) => {
    const workspaceEntry = workspaces.find((w) => w.slug === workspaceSlug);

    if (!workspaceEntry) {
      throw new Error("Workspace not found");
    }

    return workspaceEntry;
  });

  function changeWorkspace(changeWorkspaceTo: string | Workspace) {
    const changeWorkspaceToSlug =
      typeof changeWorkspaceTo === "string"
        ? changeWorkspaceTo
        : changeWorkspaceTo.slug;

    router.replace(`/${changeWorkspaceToSlug}`);
  }

  return {
    selectedWorkspace: workspace,
    setSelectedWorkspace: changeWorkspace,
  };
}

export { useWorkspace };
